if (document.documentElement.lang.toLowerCase().split('-')[0] === 'de') {
(() => {
  'use strict';
  const locale=document.documentElement.lang.toLowerCase().split('-')[0];
  if(!['en','de'].includes(locale))return;
  const route=globalThis.Shopify?.routes?.root||('/'+locale+'/');
  const base=route.endsWith('/')?route.slice(0,-1):route;
  function localizeLink(link){
    const raw=(link.getAttribute('href')||'').trim();
    if(!raw.startsWith('/')||raw.startsWith('//'))return;
    const target=new URL(raw,location.origin);
    if(/^\/en(pages|collections|products)\//.test(target.pathname))target.pathname=target.pathname.replace(/^\/en(pages|collections|products)\//,'/en/$1/');
    if(/^\/(pages|products|collections|search|policies|blogs)(\/|$)/.test(target.pathname))target.pathname=base+target.pathname;
    else if(target.pathname==='/')target.pathname=base||'/';
    link.setAttribute('href',target.pathname+target.search+target.hash);
  }
  function localizeLinks(root){
    if(root.matches?.('a[href]'))localizeLink(root);
    root.querySelectorAll('a[href]').forEach(localizeLink);
  }
  localizeLinks(document);
  new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{
    if(node.nodeType===1&&node.querySelectorAll)localizeLinks(node);
  }))).observe(document.body,{childList:true,subtree:true});
})();

} else {
(() => {
  'use strict';
  if (!document.documentElement.lang.toLowerCase().startsWith('en')) return;
  function localizeLinks(root) {
    root.querySelectorAll('a[href]').forEach(link => {
      const raw = link.getAttribute('href').trim();
      if (!raw.startsWith('/') || raw.startsWith('//')) return;
      const target = new URL(raw, location.origin);
      if (/^\/en(pages|collections|products)\//.test(target.pathname)) target.pathname = target.pathname.replace(/^\/en(pages|collections|products)\//, '/en/$1/');
      else if (/^\/(pages|products|collections|search|policies|blogs)(\/|$)/.test(target.pathname)) target.pathname = '/en' + target.pathname;
      else if (target.pathname === '/') target.pathname = '/en';
      link.setAttribute('href', target.pathname + target.search + target.hash);
    });
  }
  localizeLinks(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1 && node.querySelectorAll) localizeLinks(node);
  }))).observe(document.body, {childList:true, subtree:true});
})();


}
